import React, {
    useEffect, useContext, useState, useCallback
} from 'react';
import PropTypes from 'prop-types';
import { withRouter, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { Wizard } from '@xengage/gw-portals-wizard-react';
import { ViewModelServiceContext, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { ModalNextContext } from '@jutro/components';
import { LoaderExt } from 'gw-components-platform-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ErrorBoundary } from '@xengage/gw-portals-error-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { Claim,  ClaimUtil } from 'gw-capability-fnol-common-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import FNOLMessages from '../cpmi_FNOL-common/FNOL.messages';
import './FNOLWC.messages';
import wizardConfig from './config/fnol-wc-wizard-config.json5';
import styles from './FNOLWCWizard.module.scss';

const ACTION_MSG = {
    cancelAction: {
        title: commonMessages.wantToCancel,
        message: FNOLMessages.cancelModalMessage,
        status: 'warning',
        icon: 'mi-error-outline',
        confirmButtonText: commonMessages.yes,
        cancelButtonText: 'No'
    },
    saveAndExitAction: {
        title: FNOLMessages.saveAndExitModalTitle,
        message:<div className={styles.popUpMessage}><span className={styles.popUpBoldText}>Your entries have been saved.</span> A draft claim that starts with "T" will display on your Claims page. A "T" claim is an incomplete submission that has not been submitted for adjudication and will disappear in 7 days if not completed.</div>,
        status: 'warning',
        icon: 'mi-error-outline',
        confirmButtonText: "OK",
        cancelButtonText: 'Cancel'
    },
    previousAction: {
        title: commonMessages.wantToJump,
        message: commonMessages.wantToJumpMessage,
        status: 'warning',
        icon: 'mi-error-outline',
        confirmButtonText: commonMessages.yes,
        cancelButtonText: 'No'
    }
};


function FNOLWCWizard(props) {
    const { steps, title } = wizardConfig;
    const { location, history } = props;
    const { authHeader } = useAuthentication();
    const [getRedirectPath, setRedirectPath] = useState();
    const { FNOLService } = useDependencies('FNOLService');
    const viewModelService = useContext(ViewModelServiceContext);
    const [initialClaim, setInitialClaim] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [hasErrorOccurred, setHasErrorOccurred] = useState(false);
    const ModalNext= useContext(ModalNextContext);

    useEffect(
        () => {
            if (!location.state) {
                return history.push('/');
            }
            const { claimData, redirectPath } = location.state;
            setRedirectPath(redirectPath);
            const claimValue = new Claim(claimData);
            const claimVM = viewModelService.create(
                claimValue,
                'cc',
                'edge.capabilities.claim.fnol.dto.FnolDTO'
            );

            return setInitialClaim(claimVM);
        },
        // execute once
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const saveDraftClaim = useCallback(
        (model, toRedirectpath) => {
            const newModel = _.clone(model);
            _.set(newModel, 'documents', []);
            setIsLoading(true);
            FNOLService.saveFNOLDetails(newModel, authHeader)
                .then(() => {
                    return history.push({
                        pathname: toRedirectpath,
                        state: 'claims'
                    });
                })
                .catch(() => {
                    ModalNext.showAlert({
                        title: FNOLMessages.fnolSaveDraftErrorTitle,
                        message: FNOLMessages.fnolSaveDraftErrorMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).catch(_.noop);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        },
        [FNOLService, ModalNext, authHeader, history]
    );
    

    

    const handleOnCancel = useCallback(
        ({ wizardSnapshot, param: nextPath = '', wizardData }) => {
            if (
                (!_.isEmpty(nextPath) && nextPath.startsWith('/fnol'))
                || nextPath.startsWith('/confirmation')
                || nextPath.startsWith('/contactAgent')
                || hasErrorOccurred
            ) {
                return true;
            }
            let toRedirectpath = nextPath;
            if (_.isEmpty(nextPath)) {
                toRedirectpath = getRedirectPath;
            }
            const message = wizardSnapshot.claimNumber.value
                ? ACTION_MSG.saveAndExitAction
                : ACTION_MSG.previousAction;
            return ModalNext.showConfirm(message).then((results) => {
                if (results === 'cancel' || results === 'close') {
                    return _.noop();
                }
                setIsLoading(true);
                if (!wizardSnapshot.claimNumber.value) {
                    history.push({
                        pathname: toRedirectpath,
                        state: 'claims'
                    });
                    setIsLoading(false);
                    // returning undefined since arrow functions require return value
                    return undefined;
                }
                const isValid = wizardData.lobs.aspects.valid
                && wizardData.lobs.aspects.subtreeValid
                && wizardData.lossLocation.aspects.subtreeValid;
                const payload = isValid
                    ? _.get(wizardData, 'value')
                    : _.get(wizardSnapshot, 'value');
                return saveDraftClaim(payload, toRedirectpath);
            }, _.noop);
        },
        [hasErrorOccurred, ModalNext, getRedirectPath, saveDraftClaim, history]
    );

    // const handleOnPrevious = useCallback(
    //     ({ wizardSnapshot, param: nextPath = '', wizardData }) => {
    //         if (
    //             (!_.isEmpty(nextPath) && nextPath.startsWith('/fnol'))
    //             || nextPath.startsWith('/confirmation')
    //             || nextPath.startsWith('/contactAgent')
    //             || hasErrorOccurred
    //         ) {
    //             return true;
    //         }
           
            
    //         const message = wizardSnapshot.claimNumber.value
    //             ? ACTION_MSG.previousAction
    //             : ACTION_MSG.previousAction;
    //         return ModalNext.showConfirm(message).then((results) => {
    //             console.log(results);
    //             if (results === 'cancel') {
    //                 return _.noop();
    //             }
                
    //               return   history.go(-1);
                
                
                
    //         }, _.noop);
    //     },
    //     [hasErrorOccurred, ModalNext, history]
    // );

    // const handleError = useCallback(
    //     (error) => {
    //         const state = {
    //             pathname: ClaimUtil.getCancelPath(initialClaim.value),
    //             state: error
    //         };

    //         return ModalNext.showAlert({
    //             title: commonMessages.genericError,
    //             message: commonMessages.genericErrorMessage,
    //             status: 'error',
    //             icon: 'mi-error-outline',
    //             confirmButtonText: commonMessages.ok
    //         }).then(() => {
    //             setHasErrorOccurred(true);
    //             return <Redirect to={state} />;
    //         }, _.noop);
    //     },
    //     [ModalNext, initialClaim.value]
    // );

    if (isLoading) {
        return <LoaderExt loaded={!isLoading} text={FNOLMessages.fnolSaveDraftClaim} />;
    }

    if (!initialClaim) {
        return null;
    }

    return (
        <div className={styles.FNOLWCWizardContainer}>
        
            {/*< ErrorBoundary onError={handleError}></ErrorBoundary >  */}
            <Wizard
                initialSteps={steps}
                wizardTitle={title}
                initialData={initialClaim}
                skipCompletedSteps
               // onPrevious={handleOnPrevious}
                onCancel={handleOnCancel}
                onPreviousModalProps={{
                    title: commonMessages.wantToJump,
                    message: commonMessages.wantToJumpMessage,
                    status: 'warning',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.yesModel,
                    cancelButtonText: commonMessages.noModel
                }}
            />
            {/*  </ErrorBoundary>  */}

        </div>
    );
}
FNOLWCWizard.propTypes = {
    location: PropTypes.shape({
        state: PropTypes.shape({
            claimData: PropTypes.shape({}),
            redirectPath: PropTypes.string
        })
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired
};
export default withRouter(withViewModelService(FNOLWCWizard));